import React from 'react';

import { ReactFCV } from '@types';

import { PageWrapper } from '../../styled';

import { ButtonsSkeleton, CartSkeleton, FormSkeleton } from './components';

export const SummaryPageSkeleton: ReactFCV = () => (
  <PageWrapper data-testid="checkout-wrapper">
    <FormSkeleton data-testid="form-skeleton" />
    <CartSkeleton data-testid="cart-skeleton" />
    <ButtonsSkeleton data-testid="buttons-skeleton" />
  </PageWrapper>
);
